// Sample product data - replace with Supabase data in production
export const products = [
  // === THE BIG THREE ===
  {
    id: 'apple-teether',
    name: 'Apple Explorer',
    slug: 'apple-explorer',
    category: 'teethers',
    price: 22.95,
    comparePrice: null,
    description: 'A familiar apple-shaped teether with graduated textures from smooth skin to bumpy seeds. Apple is the most common first fruit for babies — this teether builds oral familiarity with its recognisable shape and colour while supporting sensory exploration from day one.',
    shortDescription: 'The classic first fruit, reimagined for tiny hands',
    features: [
      '100% food-grade silicone',
      'Graduated texture zones from smooth to detailed',
      'Realistic apple shape for visual familiarity',
      'Lightweight stem grip for developing hands',
      'Dishwasher and freezer safe',
    ],
    developmentalBenefits: [
      'Supports oral sensory exploration and haptic learning',
      'Builds visual familiarity with real food shapes',
      'Encourages hand-to-mouth coordination',
      'Multiple textures stimulate diverse oral receptors',
    ],
    ageRange: '0+ months',
    images: [
      '/images/products/apple-1.jpg',
      '/images/products/apple-2.jpg',
    ],
    colors: ['blush', 'sage'],
    inStock: true,
    featured: true,
    bestseller: true,
  },
  {
    id: 'banana-teether',
    name: 'Banana Buddy',
    slug: 'banana-buddy',
    category: 'teethers',
    price: 22.95,
    comparePrice: null,
    description: 'An instantly recognisable banana-shaped teether with a natural curve that fits tiny mouths perfectly. Banana is one of the most trusted first foods worldwide — this teether supports oral exploration through its distinctive curved form and graduated peel-to-flesh textures.',
    shortDescription: 'The universally loved first food, naturally shaped to soothe',
    features: [
      '100% food-grade silicone',
      'Natural curve fits infant mouth ergonomically',
      'Peel-to-flesh graduated texture progression',
      'Easy-grip shape for self-directed exploration',
      'Dishwasher and freezer safe',
    ],
    developmentalBenefits: [
      'Curved form encourages lateral mouth exploration',
      'Builds familiarity with a universally recognised food shape',
      'Supports self-directed oral sensory learning',
      'Varied textures engage multiple oral receptor classes',
    ],
    ageRange: '0+ months',
    images: [
      '/images/products/banana-1.jpg',
      '/images/products/banana-2.jpg',
    ],
    colors: ['butter', 'sage'],
    inStock: true,
    featured: true,
    bestseller: true,
  },
  {
    id: 'carrot-teether',
    name: 'Carrot Companion',
    slug: 'carrot-companion',
    category: 'teethers',
    price: 22.95,
    comparePrice: null,
    description: 'Our charming carrot teether features a soft leafy top and textured body. Carrot is the most common single-ingredient vegetable in baby foods — this teether builds oral familiarity with its recognisable form while graduated textures support sensory exploration from the very first days.',
    shortDescription: 'The most trusted first vegetable, soft textures for early explorers',
    features: [
      '100% food-grade silicone',
      'Soft flexible design',
      'Lightweight for newborns',
      'Easy to clean',
    ],
    developmentalBenefits: [
      'Supports early oral sensory exploration from birth',
      'Builds visual and oral familiarity with real vegetable shapes',
      'Gentle textures engage developing oral receptors',
    ],
    ageRange: '0+ months',
    images: [
      '/images/products/carrot-1.jpg',
      '/images/products/carrot-2.jpg',
    ],
    colors: ['terracotta', 'butter'],
    inStock: true,
    featured: true,
    bestseller: true,
  },
  // === BIG FOUR CONTENDER ===
  {
    id: 'broccoli-teether',
    name: 'Broccoli Buddy',
    slug: 'broccoli-buddy',
    category: 'teethers',
    price: 24.95,
    comparePrice: null,
    description: 'A textured broccoli teether with a bumpy floret top perfect for massaging sore gums. Broccoli is offered as a first food for over a quarter of babies, yet is underrepresented in commercial baby products — making this teether a unique way to build early familiarity with an aspirational vegetable.',
    shortDescription: 'Textured florets for the aspirational first vegetable',
    features: [
      '100% food-grade silicone',
      'Bumpy massage texture',
      'Ergonomic stem handle',
      'Freezer safe',
    ],
    developmentalBenefits: [
      'Complex floret textures promote advanced oral discrimination',
      'Builds familiarity with a vegetable underrepresented in commercial formats',
      'Ergonomic stem supports grip strength development',
    ],
    ageRange: '4+ months',
    images: [
      '/images/products/broccoli-1.jpg',
      '/images/products/broccoli-2.jpg',
    ],
    colors: ['sage'],
    inStock: true,
    featured: true,
    bestseller: false,
  },
  // === GIFT SETS ===
  {
    id: 'first-foods-trio',
    name: 'First Foods Trio',
    slug: 'first-foods-trio',
    category: 'gift-sets',
    price: 59.95,
    comparePrice: 68.85,
    description: 'The perfect introduction to sensory exploration. This set includes our three most popular first-food teethers — Apple Explorer, Banana Buddy, and Carrot Companion — chosen because these are the foods parents reach for first. A beautiful way to start building food familiarity from day one.',
    shortDescription: 'Apple, Banana & Carrot — the essential first-food trio',
    features: [
      'Includes Apple Explorer, Banana Buddy & Carrot Companion',
      'Organic cotton storage pouch',
      'Gift-ready packaging',
      'Save $8.90 on bundle',
    ],
    developmentalBenefits: [
      'Progressive texture exploration across three shapes',
      'Builds familiarity with the most common first foods',
      'Supports oral sensory development from birth',
    ],
    ageRange: '0+ months',
    images: [
      '/images/products/trio-set-1.jpg',
      '/images/products/trio-set-2.jpg',
    ],
    colors: null,
    inStock: true,
    featured: true,
    bestseller: true,
  },
  {
    id: 'veggie-gift-set',
    name: 'Garden Starter Set',
    slug: 'garden-starter-set',
    category: 'gift-sets',
    price: 64.95,
    comparePrice: 72.85,
    description: 'The perfect gift for new parents! This set includes our beloved Carrot Companion, Broccoli Buddy, and a matching organic cotton pouch.',
    shortDescription: 'Three teethers in a gift-ready set',
    features: [
      'Includes 3 teethers',
      'Organic cotton storage pouch',
      'Gift-ready packaging',
      'Save $7.90 on bundle',
    ],
    developmentalBenefits: [
      'Progressive texture exploration',
      'Variety of grip options',
      'Extended developmental support',
    ],
    ageRange: '0+ months',
    images: [
      '/images/products/gift-set-1.jpg',
      '/images/products/gift-set-2.jpg',
    ],
    colors: null,
    inStock: true,
    featured: false,
    bestseller: false,
  },
  // === OTHER TEETHERS ===
  {
    id: 'avocado-teether',
    name: 'Avocado Explorer',
    slug: 'avocado-explorer',
    category: 'teethers',
    price: 24.95,
    comparePrice: null,
    description: 'A delightful avocado-shaped teether with graduated textures to soothe sore gums and introduce sensory exploration.',
    shortDescription: 'Graduated textures for sensory development',
    features: [
      '100% food-grade silicone',
      'Multiple texture zones',
      'Easy to grip for tiny hands',
      'Dishwasher safe',
    ],
    developmentalBenefits: [
      'Encourages hand-eye coordination',
      'Introduces varied textures',
      'Promotes self-soothing',
    ],
    ageRange: '3+ months',
    images: [
      '/images/products/avocado-1.jpg',
      '/images/products/avocado-2.jpg',
    ],
    colors: ['sage', 'terracotta'],
    inStock: true,
    featured: false,
    bestseller: false,
  },
  {
    id: 'mushroom-teether',
    name: 'Mushroom Magic',
    slug: 'mushroom-magic',
    category: 'teethers',
    price: 26.95,
    comparePrice: 29.95,
    description: 'An enchanting mushroom teether with varied textures across the cap and stem, designed to engage curious little explorers.',
    shortDescription: 'Multi-textured cap and stem design',
    features: [
      '100% food-grade silicone',
      'Dual-texture design',
      'Standing base for easy storage',
      'BPA and phthalate free',
    ],
    developmentalBenefits: [
      'Promotes texture discrimination',
      'Supports fine motor skills',
      'Encourages exploration',
    ],
    ageRange: '3+ months',
    images: [
      '/images/products/mushroom-1.jpg',
      '/images/products/mushroom-2.jpg',
    ],
    colors: ['blush', 'sage'],
    inStock: true,
    featured: false,
    bestseller: false,
  },
  {
    id: 'strawberry-teether',
    name: 'Strawberry Sweetie',
    slug: 'strawberry-sweetie',
    category: 'teethers',
    price: 22.95,
    comparePrice: null,
    description: 'A sweet strawberry teether with seed-like bumps that provide gentle stimulation for developing gums.',
    shortDescription: 'Gentle bumps for soothing relief',
    features: [
      '100% food-grade silicone',
      'Seed texture detail',
      'Soft leafy grip area',
      'Non-toxic materials',
    ],
    developmentalBenefits: [
      'Tactile sensory input',
      'Self-soothing support',
      'Colour recognition',
    ],
    ageRange: '3+ months',
    images: [
      '/images/products/strawberry-1.jpg',
      '/images/products/strawberry-2.jpg',
    ],
    colors: ['blush', 'terracotta'],
    inStock: true,
    featured: false,
    bestseller: false,
  },
]

export const categories = [
  { id: 'teethers', name: 'Teethers', description: 'Sensory teethers for developmental milestones' },
  { id: 'gift-sets', name: 'Gift Sets', description: 'Curated bundles perfect for gifting' },
  { id: 'accessories', name: 'Accessories', description: 'Clips, pouches, and more' },
]

export const getFeaturedProducts = () => products.filter((p) => p.featured)
export const getBestsellers = () => products.filter((p) => p.bestseller)
export const getProductBySlug = (slug) => products.find((p) => p.slug === slug)
export const getProductsByCategory = (category) =>
  category ? products.filter((p) => p.category === category) : products
